<script setup lang="ts">

import {ArrowDownBold, ArrowUpBold} from "@element-plus/icons-vue";

const model = defineModel();
const props = defineProps({
  isOpen: Boolean,
  title: String,
  min_value: Number,
  max_value: Number,
  step: Number
});
</script>

<template>
  <div class="flex items-center h-full">
    <el-dropdown trigger="click" @visible-change="val => isOpen = val">
        <span class="el-dropdown-link flex items-center">
          {{ title }}
          <el-icon class="el-icon--right ml-1">
            <component :is="isOpen ? ArrowUpBold : ArrowDownBold" />
          </el-icon>
        </span>
      <template #dropdown>
        <div class="p-4 w-64 bg-background-light shadow-lg rounded overflow-x-hidden">
          <el-slider
              v-model="model"
              range
              :min="min_value"
              :max="max_value"
              :step="step"
              show-tooltip
              tooltip-class="custom-slider-tooltip"
          />
        </div>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped>

</style>
